import React from "react";
import classNames from "classnames";
import { Button, Modal } from "react-bootstrap";
import { OrderModalProps } from "../../types/order";

const CancelOrderModal = ({
    show,
    handleClose,
    handleSubmit,
}: OrderModalProps): React.JSX.Element => {
    return (
        <Modal show={show} onHide={() => handleClose()}>
            <Modal.Header>
                <Modal.Title className={classNames("text-center")}>
                    Are you show you want to cancel this order?
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Cancelling the order will:
                <ul>
                    <li>
                        Cancel <b>all</b> ordered products!
                    </li>
                    <li>Update coupon usage (if applicable)</li>
                    <li>
                        Update the number of open spots in the respective
                        tournament(s)
                    </li>
                    <li>
                        Remove the listed team(s) from their respective
                        tournament(s)
                    </li>
                </ul>
                <h6 className="text-center text-danger">
                    Changing the status back after cancelling and saving will
                    not undo the above changes!
                </h6>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => handleClose()}>
                    No
                </Button>
                <Button
                    variant="danger"
                    onClick={() => handleSubmit("cancelOrder", handleClose)}
                >
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CancelOrderModal;
